




















// Vue
import { Component, Vue, Prop } from 'vue-property-decorator'

// Model
import { LunchControlForm } from '@/models/dailyControl'
import { EmployeeModel, RateLunch } from '@/models/config'

// Components
import { FormCreateEditLunchControl } from '@/components/dailyControl'

@Component({
    name: 'ModalCreateEditLunchControl',
    components: {
        FormCreateEditLunchControl
    }
})
export default class ModalCreateEditLunchControl extends Vue {
    @Prop({ type: Boolean, required: true, default: false }) show!: boolean
    @Prop({ type: String, default: 'save' }) actionForm!: string
    @Prop({ type: Number, default: null }) idEdit!: number|null
    @Prop({ required: true }) lunchControl!: LunchControlForm
    @Prop({ type: Array, default: () => [] }) employees!: EmployeeModel[]
    @Prop({ type: Array, default: () => [] }) rateLunchs!: RateLunch[]

    get title () {
        if (this.actionForm === 'save') {
            return 'Agregar Control de Refrigerio de Empleados'
        }
        return 'Agregar Control de Refrigerio de Empleados'
    }
}
